import { BaseGrid } from '@/grid/BaseGrid';
import { Cell } from '@/grid/Cell';
import { PathResult, AlgorithmStep } from './PathResult';
import { HeuristicFunction } from './Heuristic';

export interface AlgorithmOptions {
  heuristic?: HeuristicFunction;
  weight?: number;
}

export abstract class PathFinder {
  abstract readonly name: string;
  abstract readonly description: string;

  abstract findPath(
    grid: BaseGrid,
    start: Cell,
    goal: Cell,
    options?: AlgorithmOptions
  ): PathResult;

  abstract findPathStepByStep(
    grid: BaseGrid,
    start: Cell,
    goal: Cell,
    options?: AlgorithmOptions
  ): Generator<AlgorithmStep, PathResult, undefined>;

  protected reconstructPath(goal: Cell): Cell[] {
    const path: Cell[] = [];
    let current: Cell | null = goal;

    while (current !== null) {
      path.unshift(current);
      current = current.parent;
    }

    return path;
  }
}
